'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _components = require('../../components');
var _LeadsList = require('./LeadsList.scss');var styles = _interopRequireWildcard(_LeadsList);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var LeadsList = function LeadsList(props) {var

  translate =
















  props.translate,data = props.data,locale = props.locale,isMobile = props.isMobile,openDetailsPopup = props.openDetailsPopup,sendViewLeadPhone = props.sendViewLeadPhone,userToken = props.userToken,firstIndex = props.firstIndex,rowsOnPage = props.rowsOnPage,openMessageModal = props.openMessageModal,hideMessageModal = props.hideMessageModal,canOpenLead = props.canOpenLead,handleOpenBuyModal = props.handleOpenBuyModal,changeNumberLeads = props.changeNumberLeads,setDensityUnreadLeads = props.setDensityUnreadLeads,numberUnreadLeads = props.numberUnreadLeads,userLeads = props.userLeads;

  var renderCell = function renderCell(item, index) {return (
      _react2.default.createElement(_components.LeadItem, {
        key: item.id,
        id: item.id,
        name: item.name,
        viewedAt: item.viewed_at,
        sentDate: item.created_at,
        property: item.entity,
        phone: item.phone_number,
        email: item.email,
        message: item.message,
        messengers: item.messengers,
        aims: item.aims,
        isViewed: item.is_viewed,
        entity_type: item.entity_type,
        numberInOrder: firstIndex + index,
        translate: translate,
        locale: locale,
        isMobile: isMobile,
        openDetailsPopup: openDetailsPopup,
        sendViewLeadPhone: sendViewLeadPhone,
        userToken: userToken,
        openMessageModal: openMessageModal,
        hideMessageModal: hideMessageModal,
        canOpenLead: canOpenLead,
        changeNumberLeads: changeNumberLeads,
        handleOpenBuyModal: handleOpenBuyModal,
        setDensityUnreadLeads: setDensityUnreadLeads,
        numberUnreadLeads: numberUnreadLeads,
        userLeads: userLeads }));};



  return (
    _react2.default.createElement('div', { className: styles.leadsList },
      data && data.slice(firstIndex, firstIndex + rowsOnPage.value).map(renderCell)));


};

LeadsList.propTypes = {
  changeNumberLeads: _propTypes2.default.func,
  data: _propTypes2.default.array,
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  openDetailsPopup: _propTypes2.default.func,
  sendViewLeadPhone: _propTypes2.default.func,
  userToken: _propTypes2.default.string,
  firstIndex: _propTypes2.default.number,
  rowsOnPage: _propTypes2.default.object,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  canOpenLead: _propTypes2.default.bool,
  userLeads: _propTypes2.default.object,
  handleOpenBuyModal: _propTypes2.default.func,
  numberUnreadLeads: _propTypes2.default.number,
  setDensityUnreadLeads: _propTypes2.default.func };exports.default =


LeadsList;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LeadsList/LeadsList.js
// module id = 2704
// module chunks = 0